<template>
    <el-dropdown trigger="click" @command="handleSetSize">
        <div>
            <svg-icon class-name="size-icon" icon-class="size" />
        </div>
        <el-dropdown-menu slot="dropdown">
            <el-dropdown-item :disabled="size === 'Small'" command="Small">
                {{ $t("_small") }}
            </el-dropdown-item>
            <el-dropdown-item :disabled="size === 'Medium'" command="Medium">
                {{ $t("_medium") }}
            </el-dropdown-item>
            <el-dropdown-item :disabled="size === 'Big'" command="Big">
                {{ $t("_big") }}
            </el-dropdown-item>
        </el-dropdown-menu>
    </el-dropdown>
</template>
 
<script>
import { SaveSystem_theme } from "@/api/rms86/setup_system_theme";
export default {
    inject: ['reload'],
    computed: {
        size() {
            return this.$store.getters.size
        }
    },
    methods: {
        handleSetSize(size) {
            // 保存主题到system_theme表
            var current_selected_menu_theme=this.$store.getters.current_menu_theme.background === undefined ? { "background": "#304156", "color": "rgb(191, 203, 217)" } : this.$store.getters.current_menu_theme;
            var current_selected_nav_theme= this.$store.getters.current_nav_theme.background === undefined ? { "background": "#3c8dbc", "color": "#fff" } : this.$store.getters.current_nav_theme;
            var current_selected_body_theme= this.$store.getters.current_body_theme.background === undefined ? { "background": "#ffffff", "color": "#606266" } : this.$store.getters.current_body_theme;
            var current_selected_body_theme_striped= this.$store.getters.current_body_theme_striped.background === undefined ? { "background": "#6c757d", "color": "#fff" } : this.$store.getters.current_body_theme_striped;
            
            var g_data = {
                menu_theme: JSON.stringify(current_selected_menu_theme),
                nav_theme: JSON.stringify(current_selected_nav_theme),
                body_theme: JSON.stringify(current_selected_body_theme),
                body_theme_striped: JSON.stringify(current_selected_body_theme_striped),
                font_type: size
            }
            SaveSystem_theme(g_data).then((data) => {
                // 保存成功提示
                if (data.success === 1) {
                    // 更新到store中
                    this.$store.dispatch('setSize', size);
                    //切換字體後必須刷新否則頁面樣式亂
                    this.reload();
                    //處理手機端切換時需折疊
                    if (this.IsMobile() != null) {
                        this.$store.state.tab.isCollapse = false;
                    }
                    this.$message({
                        message: this.$t('_switch_size'),
                        type: 'success'
                    })
                }
                // 失败异常提示
                else {
                    this.loading = false;
                    this.$message({
                        type: "danger",
                        message: data.message,
                    });
                }
            });


            // this.$store.dispatch('setSize', size)         
            // //切換字體後必須刷新否則頁面樣式亂    
            // this.reload();
            // //處理手機端切換時需折疊
            // if (this.IsMobile() != null) {
            //     this.$store.state.tab.isCollapse = false;             
            // }
            // this.$message({
            //     message: this.$t('_switch_size'),
            //     type: 'success'
            // })
        }
    }
}
</script>